import clsx from 'clsx'
import Header, { HeaderProps } from '../Header/Header'
import Icon from '../Icon/Icon'

export interface OriginDestinationHeaderProps
  extends Omit<HeaderProps, 'children'> {
  /**
   * The name of the origin location, appears before the arrow icon
   */
  origin: string
  /**
   * The name of the destination location, appears after the arrow icon
   */
  destination: string
  /**
   * The optional class for icon
   */
  iconClassName?: string
}

export default function OriginDestinationHeader({
  origin,
  destination,
  as = 'h2',
  className = 'type-body-3',
  iconClassName,
  overrideClassName = true,
}: OriginDestinationHeaderProps) {
  return origin && destination ? (
    <Header
      as={as}
      className={clsx('flex items-center justify-between', className)}
      overrideClassName={overrideClassName}
      aria-label={[origin, destination].join(' to ')}
    >
      <span className="">{origin}</span>
      <Icon
        icon="arrow-right"
        className={clsx('w-[1.3em] h-[1.3em] mt-[-0.17em] mx-2', iconClassName)}
        aria-hidden
      />{' '}
      <span className="">{destination}</span>
    </Header>
  ) : null
}
